import { LoginPage as KitLoginPage } from 'auth-sso-kit/client';

export function LoginPage() {
  return (
    <KitLoginPage
      title="Budget"
      subtitle="Suivi budgétaire et salarial — L'Éveil"
      emailPlaceholder="prenom.nom@aeveil.ch"
    />
  );
}
